import { sprintf } from 'sprintf-js';

import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

import { ProductType } from './products.types';

const URLS = {
  PRODUCTS: '/products/',
  PRIVATE_PRODUCTS: '/org/%s/products/',
  PRIVATE_PRODUCT: '/org/%s/products/%s/',
  PRODUCT: '/products/%s/',
};

export default {
  getProducts: (params?: SearchParamsType) =>
    apiInstance.request({
      method: 'GET',
      url: URLS.PRODUCTS,
      params: {
        ...params,
        ordering: 'slug',
      },
    }),
  getPrivateProducts: (orgName: any) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.PRIVATE_PRODUCTS, orgName),
    }),
  getPrivateProduct: ({ orgName, slug }: { orgName: string; slug: string }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.PRIVATE_PRODUCT, orgName, slug),
    }),
  createProduct: (product: ProductType) =>
    apiInstance.request({
      method: 'POST',
      url: URLS.PRODUCTS,
      data: product,
    }),
  getProduct: ({ slug }: { slug: ProductType['slug'] }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.PRODUCT, slug),
    }),
  updateProduct: (briefing: ProductType) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.PRODUCT, briefing.slug),
      data: briefing,
    }),
  removeProduct: ({ slug }: { slug: ProductType['slug'] }) =>
    apiInstance.request({
      method: 'DELETE',
      url: sprintf(URLS.PRODUCT, slug),
    }),
};
